
/**
 * AdobePSDK is a defined global that runs on the set top box
 * and is built into webkit. This module exposes it to our
 * internal typescript code.
 */

declare let global: any;
export const AdobePSDK = global.AdobePSDK;
